"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketAnalyticsConfigurationInput = {
    type: "structure",
    required: ["Bucket", "Id"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Id: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "id"
        }
    }
};
//# sourceMappingURL=GetBucketAnalyticsConfigurationInput.js.map